import styled from "styled-components";
import { Modal } from "@mui/material";

import { Cross } from "@/assets/icons";
import { breakpoints } from "@/styles/breakpoints";

export const StyledModal = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ModalDialogHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 8px 24px;
    vertical-align: middle;
    background-color: var(--color-secondary-light);
    border-radius: var(--radius-top-10);
`;

export const ModalDialogTitle = styled.span`
    font-size: var(--size-18);
    font-weight: var(--weight-600);
    color: var(--color-primary);
`;

export const StyledCross = styled(Cross)`
    font-size: var(--size-24);
    color: var(--color-secondary);
`;

export const ModalDialogBody = styled.div<{ $fullSize: boolean }>`
    min-width: 200px;
    min-height: 50px;
    padding: 24px;
    background: var(--color-white);
    border-radius: var(--radius-bottom-10);
    ${(props) =>
        props.$fullSize &&
        `
            display: flex;
            width: 70vw;
            height: 70vh;
            overflow-y: scroll;

            @media ${breakpoints.xs} {
                display: block;
                width: 85vw;
                height: 65vh;
            }
  `}
`;
